import { render, staticRenderFns } from "./InheemsMenu.vue?vue&type=template&id=72092478&"
import script from "./InheemsMenu.vue?vue&type=script&lang=js&"
export * from "./InheemsMenu.vue?vue&type=script&lang=js&"
import style0 from "./InheemsMenu.vue?vue&type=style&index=0&id=72092478&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports